import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageShell } from "@/components/layout/PageShell";
import { LoginForm } from "@/components/LoginForm";
import { EmptyState } from "@/components/states";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { featureEnabled, useStorefront } from "@/lib/storefront";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const { t } = useI18n();
  const bootstrap = useStorefront();
  const { isAuthenticated, hydrated } = useAuth();
  const navigate = useNavigate();
  const accountsAvailable = featureEnabled(bootstrap, "customer_accounts") && featureEnabled(bootstrap, "phone_verification");

  useEffect(() => {
    if (hydrated && isAuthenticated) navigate({ to: "/account", replace: true });
  }, [hydrated, isAuthenticated, navigate]);

  if (!accountsAvailable || bootstrap.mode === "preview") {
    return <PageShell size="narrow"><EmptyState title={t("checkout.accountUnavailable")} /></PageShell>;
  }

  return (
    <PageShell size="narrow">
      <div className="surface-card mx-auto max-w-md p-8">
        <h1 className="text-2xl font-black">{t("login.title")}</h1>
        <div className="mt-4">
          <LoginForm onSuccess={() => navigate({ to: "/account" })} />
        </div>
      </div>
    </PageShell>
  );
}
